import React from 'react';

const FormSelectionDialog = ({ isOpen, onClose, formTypes, onSelectForm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="form-selection-dialog" role="dialog" aria-modal="true">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>

        {/* Dialog positioning */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        
        {/* Dialog panel */}
        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div>
            <div className="mt-3 text-center sm:mt-0 sm:text-left">
              <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" id="modal-title">
                Select Form Type
              </h3>
              <div className="mt-4 max-h-80 overflow-y-auto">
                <div className="grid grid-cols-1 gap-3">
                  {formTypes.map((formType) => (
                    <button
                      key={formType.id}
                      onClick={() => {
                        if (formType.available) {
                          onSelectForm(formType.id);
                          onClose();
                        }
                      }}
                      disabled={!formType.available}
                      className={`
                        w-full px-4 py-3 text-left rounded-lg border transition-colors
                        ${formType.available 
                          ? 'border-gray-300 hover:bg-blue-50 hover:border-blue-300' 
                          : 'border-gray-200 bg-gray-50 cursor-not-allowed'}
                      `}
                    >
                      <div className="flex items-center justify-between">
                        <span className={`font-medium ${formType.available ? 'text-gray-800' : 'text-gray-400'}`}>
                          {formType.name}
                        </span>
                        {!formType.available && (
                          <span className="text-xs bg-gray-200 text-gray-600 px-2 py-1 rounded">
                            Coming Soon
                          </span>
                        )}
                        {formType.available && (
                          <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                          </svg>
                        )}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5 sm:mt-6">
            <button
              type="button"
              className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:text-sm"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormSelectionDialog;
